import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-fertilize-inspection',
  templateUrl: './fertilize-inspection.component.html',
  styleUrls: ['./fertilize-inspection.component.scss']
})
export class FertilizeInspectionComponent {
  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  fertilizerData: any[] = [];
  circlesList: any[] = [];
  fertilizerDeportForm!: FormGroup;
  rows: any[] = [];
  months: any[] = [];
  showButton = false
  currentMonth: any = {};
  monthKeyMap: Record<number, string> = {
  1: 'april',
  2: 'may',
  3: 'june',
  4: 'july',
  5: 'august',
  6: 'september',
  7: 'october',
  8: 'november',
  9: 'december',
  10: 'january',
  11: 'february',
  12: 'march'
  };
  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;


    const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"



    this.fertilizerDeportForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }, Validators.required],
      dataMonth: [{ value: '', disabled: false }, Validators.required],
      noOfDepot: [0, [Validators.required, Validators.min(0)]],
      noOfInspectionDone: [0, [Validators.required, Validators.min(0)]],


    });
    // this.GetConsumerGoods();.
    this.getTargetCount();
    this.GetYearAndMonth();

    
          switch (this.UserDetails?.roleId) {
      case 13:
       
        break;
      case 1:
             this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
       this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();
       
    
        break;
      default:
    }
      this.targetForm.valueChanges
            .pipe(debounceTime(300))  // waits 300ms after last change
            .subscribe(values => {
              if (this.targetForm.valid) {
                this.GetFertilizerDepotInspection();
              }
            });
  }

  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if(this.UserDetails?.roleId !== 1){
       this.blockList = res.data.blocks;
        }
 
          this.financialYears = res.data.financialYears
           if(this.UserDetails?.roleId ==11){
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
            this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {
  
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
        
 
    
      }
    },
      (error: any) => {
      }
    );
  }

   GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId":0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }
 
    
    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
            
        this.blockList = res.data?.block;
          this.targetForm.controls['blockOffice'].setValue('');
    
      }
    },
      (error: any) => {
      }
    );
  }
  GetFertilizerDepotInspection() {
    let obj = {
      blockId: this.targetForm.getRawValue().blockOffice.toString(),
      "financialYear": this.targetForm.value?.financialYear?.financialYear
    }
    this.reportService.GetFertilizerDepotInspection(obj).subscribe((res: any) => {
      if (res && res?.data && res?.data.length > 0) {
            let lastRow = res?.data[res?.data.length - 1];
           
            this.fertilizerData =res?.data
            if (Number(lastRow?.dataMonth) != 12 && Number(lastRow?.dataMonth) < 12) {
                     let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
                 let year = (Number(lastRow?.dataMonth) <= 9)? fyear?.split('-')[0] :fyear.split('-')[1] 
             
             this.currentMonth.key = (Number(lastRow?.dataMonth) + 1).toString();
              this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.dataMonth) + 1)] + ', ' + year
                     this.showButton = true
            } else {
              this.showButton = false
            }


          } else {
         this.fertilizerData = []
            this.showButton = true;
            this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
            this.currentMonth.key = '1';
              this.toastService.showInfo('NO Data Found!')
          }
    },
      (error: any) => {
      }
    );
  }
  GetYearAndMonth() {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;

        // this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }
  addData() {
    this.fertilizerDeportForm.patchValue({
      financialYear: this.targetForm.value?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth:this.currentMonth.key
    });
  }


  onSubmit() {
    if (this.fertilizerDeportForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const payload = this.fertilizerDeportForm.getRawValue();
      // let entryYear = this.reportingYears.find((i) => i?.startYear == payload?.financialYear)
      let obj = {


  "blockOffice": payload?.blockOffice,
        // "blockOfficeId": payload?.blockOffice,
        "financialYear": payload?.financialYear?.financialYear?.toString(),
        "dataMonth": +payload?.dataMonth,


    

  "totalFertilizerDepot": payload?.noOfDepot,
  "inspectionsDone": payload?.noOfInspectionDone,
  



        "createdBy": this.edit ? 0 : this.UserDetails?.id,
        "modifiedBy": this.edit ? this.UserDetails?.id : 0,
        id: this.edit ? this.editId : 0

      }

      this.reportService.AddFertilizerDepotInspection(obj).subscribe((res: any) => {
        if (res) {
         
          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('ConsumerGoodsDistributionDataModal');
            this.fertilizerDeportForm.reset();
            this.fertilizerDeportForm.markAsUntouched();
            this.GetFertilizerDepotInspection();
          }

        }
        this.edit = false
      },
        (error: any) => {
        }
      );


    } else {
      this.fertilizerDeportForm.markAllAsTouched();
    }
  }

  edit = false;
  editId = 0


  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

  editRow(row: any) {

    const data = row;
    const headerData = this.targetForm.getRawValue();


this.fertilizerDeportForm.patchValue({
    "financialYear":  headerData?.financialYear,
   blockOffice: data.blockOffice,
  dataMonth: data.dataMonth.toString(),
  noOfDepot: data.totalFertilizerDepot,
  noOfInspectionDone: data.inspectionsDone,

});
    this.editId = data?.id
    this.edit = true

    this.openModal('ConsumerGoodsDistributionDataModal');
  }

  DeleteGetFertilizerDepot(id: any) {
    this.reportService.DeleteGetFertilizerDepot(id).subscribe((res: any) => {
      if (res) {
       
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
 this.deleteIndex = 0;
          // this.hideModal();
          this.GetFertilizerDepotInspection();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyFertilizerDepot(id: any) {
    this.reportService.verifyGetFertilizerDepot(id).subscribe((res: any) => {
      if (res) {
    
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetFertilizerDepotInspection();
        }

      }
    },
      (error: any) => {
      }
    );
  }
    getMonthName(month: string | number): string {
  const months = [
  'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December' ,'January', 'February', 'March'
  ];
  const index = +month - 1;
  return months[index] || 'Unknown';
}

getYearFromFinancialYear(financialYear: string, month: string | number): string {
  const [startYear, endYear] = financialYear.split('-');
  const monthNum = +month;
  return monthNum >= 1 && monthNum <= 9 ? startYear : endYear;
}
getBalance(row: any): number {
  return (row.totalFertilizerDepot + row.inspectionsDone);
}

     deleteIndex:any
 setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete(){
   this.deleteIndex = 0;

  }
  closeModel(){
  this.fertilizerDeportForm.reset()
  this.fertilizerDeportForm.markAsUntouched()
  this.editId = 0
this.edit =false
}
}
